import axios from 'axios'
import OptionsTransformer from 'transformers/OptionsTransformer'
import MultiselectTransformer from 'transformers/MultiselectTransformer'

export default {
    getList() {
        return axios.get('unauthenticated/specialities?_fields=id,name,subSpecialities(id,name)', {
            transformResponse: [OptionsTransformer.transform('id', 'name')],
        })
    },

    getListMultiselect() {
        return axios.get('unauthenticated/specialities?_fields=id,name,subSpecialities(id,name)', {
            transformResponse: [MultiselectTransformer.transform('id', 'name', 'subSpecialities')],
        })
    },
}
